var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialFb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Facebook",
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C5.596 0 0 5.596 0 12.5c0 6.266 4.616 11.441 10.631 12.345v-9.032H7.54v-3.287h3.092V10.34c0-3.62 1.764-5.209 4.773-5.209 1.441 0 2.202.106 2.564.155v2.868h-2.053c-1.277 0-1.724 1.211-1.724 2.576v1.796h3.744l-.508 3.287h-3.234v9.058C20.293 24.045 25 18.828 25 12.5 25 5.596 19.404 0 12.5 0z",
    fill: "#E84344"
  })));
}
export default SvgSocialFb;